webpackJsonp([13],{

/***/ 1210:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "e52110fa.png";

/***/ }),

/***/ 1326:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "1033ad49.png";

/***/ }),

/***/ 1327:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "2216abf4.png";

/***/ }),

/***/ 1328:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1329);
    var insertCss = __webpack_require__(622);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./About.css", function() {
        content = require("!!../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./About.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1329:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(621)(false);
// imports


// module
exports.push([module.i, "._2YQZX{position:relative;font-weight:400}._35LRr{width:100%}._35LRr img{width:inherit}._3wLwB{max-width:450px;margin:0 auto;padding:60px 20px}.Sq8Go{font-size:16px}.rgyhD{font-weight:400;padding:10px 0;text-align:right}._2bIPi{width:100%}._2bIPi img{width:70px;margin:0 auto;display:block}._2oSEE{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-pack:distribute;justify-content:space-around;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding:60px 0}._1_7DV,._3Cy9Y{width:40%}._2Cw_x{font-weight:700;font-size:20px}._3RnPs{font-size:14px}._3Cy9Y img{width:100%}@media (max-width:767px){._2oSEE{-ms-flex-wrap:wrap;flex-wrap:wrap;padding:60px 40px}._1_7DV,._3Cy9Y{width:100%}}._3nEwt{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch;padding:60px 0}._3E_aX{width:30%;margin:5px;padding:20px;border:2px solid}.jHxAi{border-color:#e5a826}.jHxAi ._32nsB{color:#e5a826}._2KeCR{border-color:#dcefed}._2KeCR ._32nsB{color:#dcefed}._1yIbs{border-color:#daecc6}._1yIbs ._32nsB{color:#daecc6}._32nsB{font-weight:700;text-align:center;height:130px;font-size:20px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.YzmHU{padding-top:20px}@media (max-width:767px){._3nEwt{-ms-flex-wrap:wrap;flex-wrap:wrap;padding-bottom:0}._3E_aX{width:100%;margin:5px 20px}._32nsB{width:100%;display:block;height:inherit}}", ""]);

// exports
exports.locals = {
	"rowContainer": "_2YQZX",
	"headerImage": "_35LRr",
	"quoteContainer": "_3wLwB",
	"quoteText": "Sq8Go",
	"quoteName": "rgyhD",
	"dividerWrapper": "_2bIPi",
	"whyWrapper": "_2oSEE",
	"whyText": "_1_7DV",
	"whyPicture": "_3Cy9Y",
	"whyTitle": "_2Cw_x",
	"whyBody": "_3RnPs",
	"cardsContainer": "_3nEwt",
	"card": "_3E_aX",
	"cardOne": "jHxAi",
	"cardTitle": "_32nsB",
	"cardTwo": "_2KeCR",
	"cardThree": "_1yIbs",
	"cardBody": "YzmHU"
};

/***/ }),

/***/ 1484:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/react/react.js
var react = __webpack_require__(81);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/components/Layout/Layout.js + 3 modules
var Layout = __webpack_require__(740);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(635);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./node_modules/isomorphic-style-loader/lib/withStyles.js
var withStyles = __webpack_require__(624);
var withStyles_default = /*#__PURE__*/__webpack_require__.n(withStyles);

// EXTERNAL MODULE: ./public/icons/about_header.png
var about_header = __webpack_require__(1326);
var about_header_default = /*#__PURE__*/__webpack_require__.n(about_header);

// EXTERNAL MODULE: ./public/icons/about_divider.png
var about_divider = __webpack_require__(1210);
var about_divider_default = /*#__PURE__*/__webpack_require__.n(about_divider);

// EXTERNAL MODULE: ./public/icons/about_snapshot.png
var about_snapshot = __webpack_require__(1327);
var about_snapshot_default = /*#__PURE__*/__webpack_require__.n(about_snapshot);

// EXTERNAL MODULE: ./src/routes/about/About.css
var About = __webpack_require__(1328);
var About_default = /*#__PURE__*/__webpack_require__.n(About);

// CONCATENATED MODULE: ./src/routes/about/About.js
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();









var _ref = _jsx('img', {
  src: about_divider_default.a
});

var _ref2 = _jsx('img', {
  src: about_header_default.a
});

var _ref3 = _jsx('img', {
  src: about_snapshot_default.a
});

var _ref4 = _jsx('p', {}, void 0, 'In today\u2019s world, people are inundated with information. That goes for the realm of education as well. There are an infinite number of books, programs, blogs, resources, and websites that claim to have educational material. This app takes away the work of searching through all these complex sources by providing the educator or parent with hand picked activities from a variety of locations.');

var _ref5 = _jsx('p', {}, void 0, 'Additionally, activities in this resource are minimalist. There is no single set of rules for completing any activity, only guidelines and suggestions, which makes this resource incredibly flexible to individual skillsets and needs.');

var _ref6 = _jsx('p', {}, void 0, 'This resource helps children construct who they are as a learner. The activities provide opportunities for self-expression in the education environment. The goal is to help children develop confidence as learners, to see themselves as capable and creative, and to understand that they are able to direct their own learning experiences.');

var _ref7 = _jsx('p', {}, void 0, 'Due to the diversity of activities in this app, children are also provided the opportunity to explore their own interests and talents and discover what they like, what they are good at, and how to build on those skills.');

var _ref8 = _jsx('p', {}, void 0, 'This resource allows the educator to also explore their own skills and approaches. Activities provide the user with the peace of mind that they will always have something ready to go. They may rest easy knowing that ideas or inspirations are at their fingertips. This activity also allows for self-reflection on the methodology used by parents, caregivers, and educators. It allows for consideration of what works well, and what needs improvement in order to produce the best educational environment for children.');

var _ref9 = _jsx('p', {}, void 0, 'Additionally, this resource is incredibly dynamic. We are constantly striving to improve the materials we provide by adding the collection of activities, and testing out best practices.');

function About_About(props) {
  var dividerElement = _jsx('div', {
    className: About_default.a.dividerWrapper
  }, void 0, _ref);

  return _jsx('div', {
    className: 'container-fluid'
  }, void 0, _jsx('div', {
    className: classnames_default()('row', About_default.a.rowContainer)
  }, void 0, _jsx('div', {
    className: About_default.a.headerImage
  }, void 0, _ref2), _jsx('div', {
    className: About_default.a.quoteContainer
  }, void 0, _jsx('div', {
    className: About_default.a.quoteText
  }, void 0, '\u201CWe must credit the child with enormous potential and the children must feel that trust. The teacher must give up all his preconceived notions and accept the child as a co-constructor.\u201D'), _jsx('div', {
    className: About_default.a.quoteName
  }, void 0, 'Loris Malaguzzi')), dividerElement, _jsx('div', {
    className: About_default.a.whyWrapper
  }, void 0, _jsx('div', {
    className: About_default.a.whyText
  }, void 0, _jsx('p', {
    className: About_default.a.whyTitle
  }, void 0, 'WHY BITAA?'), _jsx('p', {
    className: About_default.a.whyBody
  }, void 0, 'Bitaa is an activities resource developed at a childcare centre with over 25 years in the business of early childhood education. We follow the Reggio Emilia Approach, and it has translated to the Bitaa Daily Activity Book in the form of focusing all activities on the child as a capable and competent individual. We have piloted this resource in our centres and found that it is incredible adaptable to different age groups, environments, settings, and group sizes.'), _jsx('p', {
    className: About_default.a.whyBody
  }, void 0, 'Whether you are working with four children or twenty-four grade school aged kids, this resource has something for any situation. The activities not only build on skills from the seven core developmental domains but also help to build a broader sense of confidence in the learning environment for students and educators alike.')), _jsx('div', {
    className: About_default.a.whyPicture
  }, void 0, _ref3)), dividerElement, _jsx('div', {
    className: About_default.a.cardsContainer
  }, void 0, _jsx('div', {
    className: classnames_default()(About_default.a.cardOne, About_default.a.card)
  }, void 0, _jsx('div', {
    className: About_default.a.cardTitle
  }, void 0, 'WHY SHOULD I USE THIS APPLICATION?'), _jsx('div', {
    className: About_default.a.cardBody
  }, void 0, _ref4, _ref5)), _jsx('div', {
    className: classnames_default()(About_default.a.cardTwo, About_default.a.card)
  }, void 0, _jsx('div', {
    className: About_default.a.cardTitle
  }, void 0, 'HOW DOES IT HELP MY CHILD?'), _jsx('div', {
    className: About_default.a.cardBody
  }, void 0, _ref6, _ref7)), _jsx('div', {
    className: classnames_default()(About_default.a.cardThree, About_default.a.card)
  }, void 0, _jsx('div', {
    className: About_default.a.cardTitle
  }, void 0, 'BENEFITS FOR CAREGIVERS, EDUCATORS, AND PARENTS'), _jsx('div', {
    className: About_default.a.cardBody
  }, void 0, _ref8, _ref9)))));
}

/* harmony default export */ var about_About = (withStyles_default()(About_default.a)(About_About));
// CONCATENATED MODULE: ./src/routes/about/index.js
var about__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();





var title = 'WHY BITAA?';

var about__ref = about__jsx(Layout["a" /* default */], {}, void 0, about__jsx(about_About, {
  title: title
}));

function action() {
  return {
    chunks: ['about'],
    title: title,
    component: about__ref
  };
}

/* harmony default export */ var about = __webpack_exports__["default"] = (action);

/***/ }),

/***/ 619:
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.5' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),

/***/ 620:
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(643)('wks');
var uid = __webpack_require__(638);
var Symbol = __webpack_require__(623).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),

/***/ 621:
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),

/***/ 622:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _stringify = __webpack_require__(727);

var _stringify2 = _interopRequireDefault(_stringify);

var _slicedToArray2 = __webpack_require__(729);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Isomorphic CSS style loader for Webpack
 *
 * Copyright © 2015-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

var prefix = 's';
var inserted = {};

// Base64 encoding and decoding - The "Unicode Problem"
// https://developer.mozilla.org/en-US/docs/Web/API/WindowBase64/Base64_encoding_and_decoding#The_Unicode_Problem
function b64EncodeUnicode(str) {
  return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function (match, p1) {
    return String.fromCharCode('0x' + p1);
  }));
}

/**
 * Remove style/link elements for specified node IDs
 * if they are no longer referenced by UI components.
 */
function removeCss(ids) {
  ids.forEach(function (id) {
    if (--inserted[id] <= 0) {
      var elem = document.getElementById(prefix + id);
      if (elem) {
        elem.parentNode.removeChild(elem);
      }
    }
  });
}

/**
 * Example:
 *   // Insert CSS styles object generated by `css-loader` into DOM
 *   var removeCss = insertCss([[1, 'body { color: red; }']]);
 *
 *   // Remove it from the DOM
 *   removeCss();
 */
function insertCss(styles) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$replace = _ref.replace,
      replace = _ref$replace === undefined ? false : _ref$replace,
      _ref$prepend = _ref.prepend,
      prepend = _ref$prepend === undefined ? false : _ref$prepend;

  var ids = [];
  for (var i = 0; i < styles.length; i++) {
    var _styles$i = (0, _slicedToArray3.default)(styles[i], 4),
        moduleId = _styles$i[0],
        css = _styles$i[1],
        media = _styles$i[2],
        sourceMap = _styles$i[3];

    var id = moduleId + '-' + i;

    ids.push(id);

    if (inserted[id]) {
      if (!replace) {
        inserted[id]++;
        continue;
      }
    }

    inserted[id] = 1;

    var elem = document.getElementById(prefix + id);
    var create = false;

    if (!elem) {
      create = true;

      elem = document.createElement('style');
      elem.setAttribute('type', 'text/css');
      elem.id = prefix + id;

      if (media) {
        elem.setAttribute('media', media);
      }
    }

    var cssText = css;
    if (sourceMap && typeof btoa === 'function') {
      // skip IE9 and below, see http://caniuse.com/atob-btoa
      cssText += '\n/*# sourceMappingURL=data:application/json;base64,' + b64EncodeUnicode((0, _stringify2.default)(sourceMap)) + '*/';
      cssText += '\n/*# sourceURL=' + sourceMap.file + '?' + id + '*/';
    }

    if ('textContent' in elem) {
      elem.textContent = cssText;
    } else {
      elem.styleSheet.cssText = cssText;
    }

    if (create) {
      if (prepend) {
        document.head.insertBefore(elem, document.head.childNodes[0]);
      } else {
        document.head.appendChild(elem);
      }
    }
  }

  return removeCss.bind(null, ids);
}

module.exports = insertCss;

/***/ }),

/***/ 623:
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),

/***/ 624:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(683);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(688);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(689);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(693);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(717);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(81);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(107);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _hoistNonReactStatics = __webpack_require__(256);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var contextTypes = {
  insertCss: _propTypes2.default.func
}; /**
    * Isomorphic CSS style loader for Webpack
    *
    * Copyright © 2015-present Kriasoft, LLC. All rights reserved.
    *
    * This source code is licensed under the MIT license found in the
    * LICENSE.txt file in the root directory of this source tree.
    */

function withStyles() {
  for (var _len = arguments.length, styles = Array(_len), _key = 0; _key < _len; _key++) {
    styles[_key] = arguments[_key];
  }

  return function wrapWithStyles(ComposedComponent) {
    var WithStyles = function (_Component) {
      (0, _inherits3.default)(WithStyles, _Component);

      function WithStyles() {
        (0, _classCallCheck3.default)(this, WithStyles);
        return (0, _possibleConstructorReturn3.default)(this, (WithStyles.__proto__ || (0, _getPrototypeOf2.default)(WithStyles)).apply(this, arguments));
      }

      (0, _createClass3.default)(WithStyles, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
          this.removeCss = this.context.insertCss.apply(undefined, styles);
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          setTimeout(this.removeCss, 0);
        }
      }, {
        key: 'render',
        value: function render() {
          return _react2.default.createElement(ComposedComponent, this.props);
        }
      }]);
      return WithStyles;
    }(_react.Component);

    var displayName = ComposedComponent.displayName || ComposedComponent.name || 'Component';

    WithStyles.displayName = 'WithStyles(' + displayName + ')';
    WithStyles.contextTypes = contextTypes;
    WithStyles.ComposedComponent = ComposedComponent;

    return (0, _hoistNonReactStatics2.default)(WithStyles, ComposedComponent);
  };
}

exports.default = withStyles;

/***/ }),

/***/ 626:
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),

/***/ 627:
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(632);
var IE8_DOM_DEFINE = __webpack_require__(667);
var toPrimitive = __webpack_require__(644);
var dP = Object.defineProperty;

exports.f = __webpack_require__(628) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ 628:
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(636)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ 630:
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(623);
var core = __webpack_require__(619);
var ctx = __webpack_require__(666);
var hide = __webpack_require__(631);
var has = __webpack_require__(626);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),

/***/ 631:
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(627);
var createDesc = __webpack_require__(639);
module.exports = __webpack_require__(628) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ 632:
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(633);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),

/***/ 633:
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),

/***/ 634:
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(699);
var defined = __webpack_require__(641);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),

/***/ 635:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(null, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),

/***/ 636:
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),

/***/ 637:
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ 638:
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),

/***/ 639:
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ 641:
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),

/***/ 642:
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(643)('keys');
var uid = __webpack_require__(638);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),

/***/ 643:
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(623);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});
module.exports = function (key) {
  return store[key] || (store[key] = {});
};


/***/ }),

/***/ 644:
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(633);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ 645:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(696)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(670)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),

/***/ 646:
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),

/***/ 647:
/***/ (function(module, exports) {

module.exports = true;


/***/ }),

/***/ 648:
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(632);
var dPs = __webpack_require__(698);
var enumBugKeys = __webpack_require__(651);
var IE_PROTO = __webpack_require__(642)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(668)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(703).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),

/***/ 649:
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(672);
var enumBugKeys = __webpack_require__(651);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),

/***/ 650:
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),

/***/ 651:
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),

/***/ 652:
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(627).f;
var has = __webpack_require__(626);
var TAG = __webpack_require__(620)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),

/***/ 653:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(704);
var global = __webpack_require__(623);
var hide = __webpack_require__(631);
var Iterators = __webpack_require__(637);
var TO_STRING_TAG = __webpack_require__(620)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),

/***/ 654:
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(620);


/***/ }),

/***/ 655:
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(623);
var core = __webpack_require__(619);
var LIBRARY = __webpack_require__(647);
var wksExt = __webpack_require__(654);
var defineProperty = __webpack_require__(627).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),

/***/ 656:
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),

/***/ 657:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__history__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Link_css__ = __webpack_require__(725);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Link_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Link_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions__ = __webpack_require__(662);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var mapStateToProps = function mapStateToProps(state) {
  return {
    path: state.path.path
  };
};

var mapDispatchToProps = {
  changePath: function changePath(path) {
    return function (dispatch) {
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions__["b" /* changePath */])(path));
    };
  }
};

function isLeftClickEvent(event) {
  return event.button === 0;
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

var Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Link.__proto__ || Object.getPrototypeOf(Link)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) {
        _this.props.onClick(event);
      }

      if (isModifiedEvent(event) || !isLeftClickEvent(event)) {
        return;
      }

      if (event.defaultPrevented === true) {
        return;
      }

      event.preventDefault();
      if (_this.props.to !== '#') {
        _this.props.changePath(_this.props.to);
      }
      __WEBPACK_IMPORTED_MODULE_5__history__["a" /* default */].push(_this.props.to);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Link, [{
    key: 'active',
    value: function active(path) {
      if (this.props.subPaths) {
        return this.props.subPaths.split(',').includes(path);
      }
      return path === this.props.to;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          to = _props.to,
          children = _props.children,
          subPaths = _props.subPaths,
          path = _props.path,
          changePath = _props.changePath,
          dispatch = _props.dispatch,
          styleName = _props.styleName,
          props = _objectWithoutProperties(_props, ['to', 'children', 'subPaths', 'path', 'changePath', 'dispatch', 'styleName']);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'a',
        _extends({
          className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(_defineProperty({}, __WEBPACK_IMPORTED_MODULE_6__Link_css___default.a.active, this.active(path)), __WEBPACK_IMPORTED_MODULE_6__Link_css___default.a.link, styleName),
          href: to
        }, props, {
          onClick: this.handleClick
        }),
        children
      );
    }
  }]);

  return Link;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Link.defaultProps = {
  onClick: null
};


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default()(__WEBPACK_IMPORTED_MODULE_6__Link_css___default.a)(Link)));

/***/ }),

/***/ 662:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./src/constants/index.js
var constants = __webpack_require__(106);

// CONCATENATED MODULE: ./src/actions/changeForm.js
/* eslint-disable import/prefer-default-export */


/* harmony default export */ var changeForm = (function (newState) {
  return {
    type: constants["d" /* CHANGE_FORM */],
    newState: newState
  };
});
// EXTERNAL MODULE: ./node_modules/redux-api-middleware/lib/index.js
var lib = __webpack_require__(252);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// CONCATENATED MODULE: ./src/actions/login.js
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-disable import/prefer-default-export */




/* harmony default export */ var login = (function (formstate) {
  return _defineProperty({}, lib["CALL_API"], {
    endpoint: '/login',
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formstate),
    credentials: 'include',
    types: [constants["w" /* USER_LOGIN_REQUEST */], constants["x" /* USER_LOGIN_SUCCESS */], constants["v" /* USER_LOGIN_FAILURE */]]
  });
});
// CONCATENATED MODULE: ./src/actions/logout.js
function logout__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-disable import/prefer-default-export */




/* harmony default export */ var logout = (function () {
  return logout__defineProperty({}, lib["CALL_API"], {
    endpoint: '/logout',
    method: 'POST',
    credentials: 'include',
    types: [constants["z" /* USER_LOGOUT_REQUEST */], constants["A" /* USER_LOGOUT_SUCCESS */], constants["y" /* USER_LOGOUT_FAILURE */]]
  });
});
// CONCATENATED MODULE: ./src/actions/register.js
function register__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-disable import/prefer-default-export */




/* harmony default export */ var register = (function (formState) {
  var formData = new FormData();
  var username = formState.username,
      password = formState.password,
      firstName = formState.firstName,
      lastName = formState.lastName,
      gender = formState.gender,
      phone = formState.phone,
      address = formState.address,
      billing_address = formState.billing_address,
      kidsCount = formState.kidsCount,
      kidsAges = formState.kidsAges,
      file = formState.file;


  if (file) {
    formData.append('file', file, file.name);
  }

  formData.append('username', username);
  formData.append('password', password);
  formData.append('firstName', firstName);
  formData.append('lastName', lastName);
  formData.append('gender', gender);
  formData.append('phone', phone);
  formData.append('address', address);
  formData.append('billing_address', billing_address);
  formData.append('kidsCount', kidsCount);
  formData.append('kidsAges', JSON.stringify(kidsAges));
  return register__defineProperty({}, lib["CALL_API"], {
    endpoint: '/register',
    method: 'POST',
    body: formData,
    credentials: 'include',
    types: [constants["C" /* USER_REGISTER_REQUEST */], constants["D" /* USER_REGISTER_SUCCESS */], constants["B" /* USER_REGISTER_FAILURE */]]
  });
});
// CONCATENATED MODULE: ./src/actions/editProfile.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function editProfile__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




/* harmony default export */ var editProfile = (function (formState) {
  var formData = new FormData();
  var username = formState.username,
      firstName = formState.firstName,
      lastName = formState.lastName,
      gender = formState.gender,
      phone = formState.phone,
      address = formState.address,
      billing_address = formState.billing_address,
      file = formState.file,
      image = formState.image;


  if (file) {
    formData.append('file', file, file.name);
  }

  formData.append('username', username);
  formData.append('firstName', firstName);
  formData.append('lastName', lastName);
  formData.append('gender', gender);
  formData.append('phone', phone);
  formData.append('address', address);
  formData.append('billing_address', billing_address);
  return editProfile__defineProperty({}, lib["CALL_API"], {
    endpoint: '/user/edit',
    method: 'POST',
    body: formData,
    credentials: 'include',
    types: [constants["h" /* EDIT_PROFILE_REQUEST */], {
      type: constants["i" /* EDIT_PROFILE_SUCCESS */],
      payload: function payload(action, state, res) {
        return res.json().then(function (json) {
          return { user: _extends({}, json.user, { image: image }) };
        });
      }
    }, constants["g" /* EDIT_PROFILE_FAILURE */]]
  });
});
// CONCATENATED MODULE: ./src/actions/pageUnload.js


/* harmony default export */ var pageUnload = (function () {
  return {
    type: constants["m" /* PAGE_UNLOAD */]
  };
});
// CONCATENATED MODULE: ./src/actions/deactivate.js


/* harmony default export */ var deactivate = (function () {
  return {
    type: constants["f" /* DEACTIVATE */]
  };
});
// CONCATENATED MODULE: ./src/actions/changePath.js


/* harmony default export */ var changePath = (function (path) {
  return {
    type: constants["e" /* CHANGE_PATH */],
    path: path
  };
});
// CONCATENATED MODULE: ./src/actions/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return changeForm; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "e", function() { return login; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "f", function() { return logout; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "h", function() { return register; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "d", function() { return editProfile; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "g", function() { return pageUnload; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "c", function() { return deactivate; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "b", function() { return changePath; });









/***/ }),

/***/ 664:
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(641);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),

/***/ 665:
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(626);
var toObject = __webpack_require__(664);
var IE_PROTO = __webpack_require__(642)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),

/***/ 666:
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(687);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ 667:
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(628) && !__webpack_require__(636)(function () {
  return Object.defineProperty(__webpack_require__(668)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ 668:
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(633);
var document = __webpack_require__(623).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),

/***/ 669:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(694);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(707);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),

/***/ 670:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(647);
var $export = __webpack_require__(630);
var redefine = __webpack_require__(671);
var hide = __webpack_require__(631);
var Iterators = __webpack_require__(637);
var $iterCreate = __webpack_require__(697);
var setToStringTag = __webpack_require__(652);
var getPrototypeOf = __webpack_require__(665);
var ITERATOR = __webpack_require__(620)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),

/***/ 671:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(631);


/***/ }),

/***/ 672:
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(626);
var toIObject = __webpack_require__(634);
var arrayIndexOf = __webpack_require__(700)(false);
var IE_PROTO = __webpack_require__(642)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),

/***/ 673:
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ 674:
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(672);
var hiddenKeys = __webpack_require__(651).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),

/***/ 675:
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(656);
var createDesc = __webpack_require__(639);
var toIObject = __webpack_require__(634);
var toPrimitive = __webpack_require__(644);
var has = __webpack_require__(626);
var IE8_DOM_DEFINE = __webpack_require__(667);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(628) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),

/***/ 676:
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(650);
var TAG = __webpack_require__(620)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),

/***/ 683:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(684), __esModule: true };

/***/ }),

/***/ 684:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(685);
module.exports = __webpack_require__(619).Object.getPrototypeOf;


/***/ }),

/***/ 685:
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(664);
var $getPrototypeOf = __webpack_require__(665);

__webpack_require__(686)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),

/***/ 686:
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(630);
var core = __webpack_require__(619);
var fails = __webpack_require__(636);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),

/***/ 687:
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),

/***/ 688:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),

/***/ 689:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(690);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),

/***/ 690:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(691), __esModule: true };

/***/ }),

/***/ 691:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(692);
var $Object = __webpack_require__(619).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),

/***/ 692:
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(630);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(628), 'Object', { defineProperty: __webpack_require__(627).f });


/***/ }),

/***/ 693:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(669);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),

/***/ 694:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(695), __esModule: true };

/***/ }),

/***/ 695:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(645);
__webpack_require__(653);
module.exports = __webpack_require__(654).f('iterator');


/***/ }),

/***/ 696:
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(646);
var defined = __webpack_require__(641);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),

/***/ 697:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(648);
var descriptor = __webpack_require__(639);
var setToStringTag = __webpack_require__(652);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(631)(IteratorPrototype, __webpack_require__(620)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),

/***/ 698:
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(627);
var anObject = __webpack_require__(632);
var getKeys = __webpack_require__(649);

module.exports = __webpack_require__(628) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),

/***/ 699:
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(650);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),

/***/ 700:
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(634);
var toLength = __webpack_require__(701);
var toAbsoluteIndex = __webpack_require__(702);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),

/***/ 701:
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(646);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),

/***/ 702:
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(646);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),

/***/ 703:
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(623).document;
module.exports = document && document.documentElement;


/***/ }),

/***/ 704:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(705);
var step = __webpack_require__(706);
var Iterators = __webpack_require__(637);
var toIObject = __webpack_require__(634);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(670)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),

/***/ 705:
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),

/***/ 706:
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),

/***/ 707:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(708), __esModule: true };

/***/ }),

/***/ 708:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(709);
__webpack_require__(714);
__webpack_require__(715);
__webpack_require__(716);
module.exports = __webpack_require__(619).Symbol;


/***/ }),

/***/ 709:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(623);
var has = __webpack_require__(626);
var DESCRIPTORS = __webpack_require__(628);
var $export = __webpack_require__(630);
var redefine = __webpack_require__(671);
var META = __webpack_require__(710).KEY;
var $fails = __webpack_require__(636);
var shared = __webpack_require__(643);
var setToStringTag = __webpack_require__(652);
var uid = __webpack_require__(638);
var wks = __webpack_require__(620);
var wksExt = __webpack_require__(654);
var wksDefine = __webpack_require__(655);
var enumKeys = __webpack_require__(711);
var isArray = __webpack_require__(712);
var anObject = __webpack_require__(632);
var isObject = __webpack_require__(633);
var toIObject = __webpack_require__(634);
var toPrimitive = __webpack_require__(644);
var createDesc = __webpack_require__(639);
var _create = __webpack_require__(648);
var gOPNExt = __webpack_require__(713);
var $GOPD = __webpack_require__(675);
var $DP = __webpack_require__(627);
var $keys = __webpack_require__(649);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(674).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(656).f = $propertyIsEnumerable;
  __webpack_require__(673).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(647)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(631)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),

/***/ 710:
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(638)('meta');
var isObject = __webpack_require__(633);
var has = __webpack_require__(626);
var setDesc = __webpack_require__(627).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(636)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),

/***/ 711:
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(649);
var gOPS = __webpack_require__(673);
var pIE = __webpack_require__(656);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),

/***/ 712:
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(650);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),

/***/ 713:
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(634);
var gOPN = __webpack_require__(674).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),

/***/ 714:
/***/ (function(module, exports) {



/***/ }),

/***/ 715:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(655)('asyncIterator');


/***/ }),

/***/ 716:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(655)('observable');


/***/ }),

/***/ 717:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(718);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(722);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(669);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),

/***/ 718:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(719), __esModule: true };

/***/ }),

/***/ 719:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(720);
module.exports = __webpack_require__(619).Object.setPrototypeOf;


/***/ }),

/***/ 720:
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(630);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(721).set });


/***/ }),

/***/ 721:
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(633);
var anObject = __webpack_require__(632);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(666)(Function.call, __webpack_require__(675).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),

/***/ 722:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(723), __esModule: true };

/***/ }),

/***/ 723:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(724);
var $Object = __webpack_require__(619).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),

/***/ 724:
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(630);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(648) });


/***/ }),

/***/ 725:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(726);
    var insertCss = __webpack_require__(622);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Link.css", function() {
        content = require("!!../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Link.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 726:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(621)(false);
// imports


// module
exports.push([module.i, "._47nzG{border-radius:3px!important}._9x4YY:hover,._47nzG{background-color:#efca75!important}._9x4YY:hover{color:#fff!important}", ""]);

// exports
exports.locals = {
	"active": "_47nzG",
	"link": "_9x4YY"
};

/***/ }),

/***/ 727:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(728), __esModule: true };

/***/ }),

/***/ 728:
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(619);
var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};


/***/ }),

/***/ 729:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isIterable2 = __webpack_require__(730);

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = __webpack_require__(733);

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

/***/ }),

/***/ 730:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(731), __esModule: true };

/***/ }),

/***/ 731:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(653);
__webpack_require__(645);
module.exports = __webpack_require__(732);


/***/ }),

/***/ 732:
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(676);
var ITERATOR = __webpack_require__(620)('iterator');
var Iterators = __webpack_require__(637);
module.exports = __webpack_require__(619).isIterable = function (it) {
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    // eslint-disable-next-line no-prototype-builtins
    || Iterators.hasOwnProperty(classof(O));
};


/***/ }),

/***/ 733:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(734), __esModule: true };

/***/ }),

/***/ 734:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(653);
__webpack_require__(645);
module.exports = __webpack_require__(735);


/***/ }),

/***/ 735:
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(632);
var get = __webpack_require__(736);
module.exports = __webpack_require__(619).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),

/***/ 736:
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(676);
var ITERATOR = __webpack_require__(620)('iterator');
var Iterators = __webpack_require__(637);
module.exports = __webpack_require__(619).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),

/***/ 740:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/react/react.js
var react = __webpack_require__(81);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(107);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// EXTERNAL MODULE: ./node_modules/isomorphic-style-loader/lib/withStyles.js
var withStyles = __webpack_require__(624);
var withStyles_default = /*#__PURE__*/__webpack_require__.n(withStyles);

// EXTERNAL MODULE: ./node_modules/normalize.css/normalize.css
var normalize = __webpack_require__(741);
var normalize_default = /*#__PURE__*/__webpack_require__.n(normalize);

// EXTERNAL MODULE: ./src/components/Layout/Layout.css
var Layout = __webpack_require__(743);
var Layout_default = /*#__PURE__*/__webpack_require__.n(Layout);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(635);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/components/Header/Header.css
var Header = __webpack_require__(745);
var Header_default = /*#__PURE__*/__webpack_require__.n(Header);

// EXTERNAL MODULE: ./src/components/Link/Link.js
var Link = __webpack_require__(657);

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 14 modules
var es = __webpack_require__(253);

// EXTERNAL MODULE: ./src/components/Navigation/Navigation.css
var Navigation_Navigation = __webpack_require__(747);
var Navigation_default = /*#__PURE__*/__webpack_require__.n(Navigation_Navigation);

// EXTERNAL MODULE: ./src/actions/index.js + 8 modules
var actions = __webpack_require__(662);

// EXTERNAL MODULE: ./src/constants/index.js
var constants = __webpack_require__(106);

// CONCATENATED MODULE: ./src/components/Navigation/Navigation.js
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var mapStateToProps = function mapStateToProps(state) {
  return {
    username: state.auth.user.username,
    firstname: state.auth.user.firstName,
    roleId: state.auth.user.role_id,
    userpackage: state.auth.package
  };
};

var Navigation_mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onLogoutClick: function onLogoutClick() {
      dispatch(Object(actions["f" /* logout */])());
      window.toastr.info('You have been successfully logged out!');
    }
  };
};

var _ref = _jsx('li', {}, void 0, _jsx(Link["a" /* default */], {
  to: '/app'
}, void 0, 'Bitaa App'));

var _ref2 = _jsx('li', {}, void 0, _jsx(Link["a" /* default */], {
  to: '/about'
}, void 0, 'Why Bitaa?'));

var _ref3 = _jsx('li', {}, void 0, _jsx(Link["a" /* default */], {
  to: '/howto'
}, void 0, 'How does it work?'));

var _ref4 = _jsx('li', {}, void 0, _jsx(Link["a" /* default */], {
  to: '/videos'
}, void 0, 'Videos'));

var _ref5 = _jsx('span', {
  className: 'caret'
});

var _ref6 = _jsx('li', {}, void 0, _jsx(Link["a" /* default */], {
  to: '/activity'
}, void 0, 'Short-Term Activity'));

var _ref7 = _jsx('li', {}, void 0, _jsx(Link["a" /* default */], {
  to: '/project'
}, void 0, 'Project'));

var _ref8 = _jsx('span', {
  className: 'caret'
});

var _ref9 = _jsx('li', {}, void 0, _jsx(Link["a" /* default */], {
  to: '/login'
}, void 0, 'Log In'));

var Navigation_Navigation_Navigation = function (_React$Component) {
  _inherits(Navigation, _React$Component);

  function Navigation() {
    _classCallCheck(this, Navigation);

    return _possibleConstructorReturn(this, (Navigation.__proto__ || Object.getPrototypeOf(Navigation)).apply(this, arguments));
  }

  _createClass(Navigation, [{
    key: 'simplify',
    value: function simplify(name) {
      if (name.length > 10) {
        return name.substr(0, 10).concat('...');
      }
      return name;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          username = _props.username,
          firstname = _props.firstname,
          roleId = _props.roleId,
          onLogoutClick = _props.onLogoutClick,
          userpackage = _props.userpackage;


      return _jsx('ul', {
        className: classnames_default()('nav', 'navbar-nav', 'navbar-right', Navigation_default.a.navbar, Navigation_default.a.default)
      }, void 0, _ref, _ref2, _ref3, _ref4, (roleId === constants["s" /* ROLE_SUPER_ADMIN */] || roleId === constants["o" /* ROLE_EXECUTIVE_ADMIN */]) && _jsx('li', {
        className: 'dropdown'
      }, void 0, _jsx(Link["a" /* default */], {
        to: '#',
        subPaths: '/activity,/project',
        styleName: classnames_default()('dropdown-toggle', Navigation_default.a.toggle),
        'data-toggle': 'dropdown',
        role: 'button',
        'aria-haspopup': 'true',
        'aria-expanded': 'false'
      }, void 0, 'Settings ', _ref5), _jsx('ul', {
        className: classnames_default()('dropdown-menu', Navigation_default.a.menu)
      }, void 0, _ref6, _ref7)), username && _jsx('li', {
        className: 'dropdown',
        title: firstname || username
      }, void 0, _jsx(Link["a" /* default */], {
        to: '#',
        subPaths: '/profile',
        styleName: 'dropdown-toggle',
        'data-toggle': 'dropdown',
        role: 'button',
        'aria-haspopup': 'true',
        'aria-expanded': 'false'
      }, void 0, this.simplify(firstname) || this.simplify(username), ' ', _ref8), _jsx('ul', {
        className: classnames_default()('dropdown-menu', Navigation_default.a.menu)
      }, void 0, _jsx('li', {}, void 0, _jsx(Link["a" /* default */], {
        to: '/profile'
      }, void 0, userpackage && userpackage.id === constants["l" /* PACKAGE_MULTI */] ? 'Dashboard' : 'Profile')), _jsx('li', {}, void 0, _jsx(Link["a" /* default */], {
        to: '/home',
        onClick: onLogoutClick
      }, void 0, 'Logout')))), !username && _ref9);
    }
  }]);

  return Navigation;
}(react_default.a.Component);

Navigation_Navigation_Navigation.defaultProps = {
  username: '',
  firstname: '',
  roleId: 0,
  userpackage: {}
};


/* harmony default export */ var components_Navigation_Navigation = (Object(es["connect"])(mapStateToProps, Navigation_mapDispatchToProps)(withStyles_default()(Navigation_default.a)(Navigation_Navigation_Navigation)));
// EXTERNAL MODULE: ./public/logo/logo.jpg
var logo = __webpack_require__(749);
var logo_default = /*#__PURE__*/__webpack_require__.n(logo);

// CONCATENATED MODULE: ./src/components/Header/Header.js
var Header__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();









var Header__ref = Header__jsx('button', {
  type: 'button',
  className: 'navbar-toggle',
  'data-toggle': 'collapse',
  'data-target': '#navbar'
}, void 0, Header__jsx('span', {
  className: 'icon-bar'
}), Header__jsx('span', {
  className: 'icon-bar'
}), Header__jsx('span', {
  className: 'icon-bar'
}));

var Header__ref2 = Header__jsx(components_Navigation_Navigation, {});

function Header_Header(props) {
  return Header__jsx('nav', {
    className: classnames_default()('navbar', 'navbar-default', Header_default.a.navBarCustom, Header_default.a.root)
  }, void 0, Header__jsx('div', {
    className: classnames_default()('container-fluid', Header_default.a.container)
  }, void 0, Header__jsx('div', {
    className: classnames_default()('navbar-header', Header_default.a.header)
  }, void 0, Header__jsx(Link["a" /* default */], {
    className: Header_default.a.brand,
    to: '/home'
  }, void 0, Header__jsx('img', {
    src: logo_default.a,
    className: Header_default.a.logo,
    alt: 'Parkland Players'
  })), Header__ref), Header__jsx('div', {
    className: classnames_default()('collapse', 'navbar-collapse', Header_default.a.collapse),
    id: 'navbar'
  }, void 0, Header__ref2)));
}

/* harmony default export */ var components_Header_Header = (withStyles_default()(Header_default.a)(Header_Header));
// EXTERNAL MODULE: ./src/components/Footer/Footer.css
var Footer = __webpack_require__(750);
var Footer_default = /*#__PURE__*/__webpack_require__.n(Footer);

// CONCATENATED MODULE: ./src/components/Footer/Footer.js
var Footer__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();







var Footer__ref = Footer__jsx('h3', {}, void 0, 'ABOUT BITAA');

var Footer__ref2 = Footer__jsx('div', {
  className: 'col-xs-3'
}, void 0, Footer__jsx('h3', {}, void 0, 'PAGES'), Footer__jsx('div', {}, void 0, Footer__jsx(Link["a" /* default */], {
  to: '/home'
}, void 0, 'Home')), Footer__jsx('div', {}, void 0, Footer__jsx(Link["a" /* default */], {
  to: '/app'
}, void 0, 'Bitaa App')), Footer__jsx('div', {}, void 0, Footer__jsx(Link["a" /* default */], {
  to: '/about'
}, void 0, 'Why Bitaa?')), Footer__jsx('div', {}, void 0, Footer__jsx(Link["a" /* default */], {
  to: '/howto'
}, void 0, 'How does it work?')), Footer__jsx('div', {}, void 0, Footer__jsx(Link["a" /* default */], {
  to: '/videos'
}, void 0, 'Videos')), Footer__jsx('div', {}, void 0, Footer__jsx(Link["a" /* default */], {
  to: '/login'
}, void 0, 'Log In')), Footer__jsx('div', {}, void 0, Footer__jsx(Link["a" /* default */], {
  to: '/contact'
}, void 0, 'Contact Us')), Footer__jsx('div', {}, void 0, Footer__jsx(Link["a" /* default */], {
  to: '/policy'
}, void 0, 'Privacy Policy')));

var Footer__ref3 = Footer__jsx('div', {
  className: 'col-xs-11 col-xs-offset-1'
}, void 0, '\xA9 2019 BITAA TECHNOLOGY');

function Footer_Footer(props) {
  return Footer__jsx('div', {
    className: Footer_default.a.root
  }, void 0, Footer__jsx('div', {
    className: 'container ' + Footer_default.a.container
  }, void 0, Footer__jsx('div', {
    className: 'row'
  }, void 0, Footer__jsx('hr', {
    className: Footer_default.a.line
  }), Footer__jsx('div', {
    className: 'col-xs-8 col-xs-offset-1'
  }, void 0, Footer__ref, Footer__jsx('div', {
    className: Footer_default.a.text
  }, void 0, 'We have filtered information from many sources in order to provide the best possible activities all in one place. We believe that children benefit the most from inquiry and self-directed learning.')), Footer__ref2), Footer__jsx('div', {
    className: 'row'
  }, void 0, Footer__jsx('hr', {
    className: Footer_default.a.line
  }), Footer__ref3)));
}

/* harmony default export */ var components_Footer_Footer = (withStyles_default()(Footer_default.a)(Footer_Footer));
// CONCATENATED MODULE: ./src/components/Layout/Layout.js
var Layout__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();





// external-global styles must be imported in your JS.





var Layout__ref = Layout__jsx(components_Header_Header, {});

var Layout__ref2 = Layout__jsx(components_Footer_Footer, {});

function Layout_Layout(props) {
  return Layout__jsx('div', {
    className: Layout_default.a.wrapper
  }, void 0, Layout__ref, Layout__jsx('div', {
    className: Layout_default.a.content
  }, void 0, props.children), Layout__ref2);
}

/* harmony default export */ var components_Layout_Layout = __webpack_exports__["a"] = (withStyles_default()(normalize_default.a, Layout_default.a)(Layout_Layout));

/***/ }),

/***/ 741:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(742);
    var insertCss = __webpack_require__(622);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../css-loader/index.js??ref--1-rules-1!../postcss-loader/lib/index.js??ref--1-rules-3!./normalize.css", function() {
        content = require("!!../css-loader/index.js??ref--1-rules-1!../postcss-loader/lib/index.js??ref--1-rules-3!./normalize.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 742:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(621)(false);
// imports


// module
exports.push([module.i, "/*! normalize.css v7.0.0 | MIT License | github.com/necolas/normalize.css */html{line-height:1.15;-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%}body{margin:0}article,aside,footer,header,nav,section{display:block}h1{font-size:2em;margin:.67em 0}figcaption,figure,main{display:block}figure{margin:1em 40px}hr{-webkit-box-sizing:content-box;box-sizing:content-box;height:0;overflow:visible}pre{font-family:monospace,monospace;font-size:1em}a{background-color:transparent;-webkit-text-decoration-skip:objects}abbr[title]{border-bottom:none;text-decoration:underline;-webkit-text-decoration:underline dotted;text-decoration:underline dotted}b,strong{font-weight:inherit;font-weight:bolder}code,kbd,samp{font-family:monospace,monospace;font-size:1em}dfn{font-style:italic}mark{background-color:#ff0;color:#000}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}audio,video{display:inline-block}audio:not([controls]){display:none;height:0}img{border-style:none}svg:not(:root){overflow:hidden}button,input,optgroup,select,textarea{font-family:sans-serif;font-size:100%;line-height:1.15;margin:0}button,input{overflow:visible}button,select{text-transform:none}[type=reset],[type=submit],button,html [type=button]{-webkit-appearance:button}[type=button]::-moz-focus-inner,[type=reset]::-moz-focus-inner,[type=submit]::-moz-focus-inner,button::-moz-focus-inner{border-style:none;padding:0}[type=button]:-moz-focusring,[type=reset]:-moz-focusring,[type=submit]:-moz-focusring,button:-moz-focusring{outline:1px dotted ButtonText}fieldset{padding:.35em .75em .625em}legend{-webkit-box-sizing:border-box;box-sizing:border-box;color:inherit;display:table;max-width:100%;padding:0;white-space:normal}progress{display:inline-block;vertical-align:baseline}textarea{overflow:auto}[type=checkbox],[type=radio]{-webkit-box-sizing:border-box;box-sizing:border-box;padding:0}[type=number]::-webkit-inner-spin-button,[type=number]::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}[type=search]::-webkit-search-cancel-button,[type=search]::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}details,menu{display:block}summary{display:list-item}canvas{display:inline-block}[hidden],template{display:none}", ""]);

// exports


/***/ }),

/***/ 743:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(744);
    var insertCss = __webpack_require__(622);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Layout.css", function() {
        content = require("!!../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Layout.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 744:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(621)(false);
// imports


// module
exports.push([module.i, ".slides .slick-prev{z-index:1;left:5%;background-color:#fff}.slides .slick-next{z-index:1;right:5%;background-color:#fff}.slides .slick-next:before,.slides .slick-prev:before{color:#10949d}.justify-content-center{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;display:-webkit-box;display:-ms-flexbox;display:flex}.m-1{margin:4px;margin:.25rem}.m-2{margin:8px;margin:.5rem}.mb-1{margin-bottom:8px;margin-bottom:.5rem}.mb-2{margin-bottom:4px;margin-bottom:.25rem}.mt-1{margin-top:4px;margin-top:.25rem}.mt-2{margin-top:8px;margin-top:.5rem}.mr-1{margin-right:4px;margin-right:.25rem}.mr-2{margin-right:8px;margin-right:.5rem}.ml-1{margin-left:4px;margin-left:.25rem}.ml-2{margin-left:8px;margin-left:.5rem}.align-items-center{-webkit-box-align:center;-ms-flex-align:center;align-items:center}.d-flex{display:-webkit-box;display:-ms-flexbox;display:flex}.flex-column{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.img-fluid{max-width:100%;height:auto}.navbar-default .navbar-nav>li>a{color:#000;font-size:16px;font-weight:400;line-height:1.5}i,input[type=checkbox],input[type=file]{cursor:pointer}input[type=checkbox].NEn17,input[type=checkbox]:active,input[type=checkbox]:focus{background-image:none;outline:0;-webkit-box-shadow:none;box-shadow:none}.btn-primary{background-color:#10949d}.btn-success{background-color:#00b2a6}.btn-warning{background-color:#efca75}.btn-danger{background-color:#e67e69}#g-recaptcha{width:100%;margin:0 auto;padding-left:17px}section{height:100%;width:100%}.rbc-time-content{display:none}.carousel-indicators .active{background:gray}@media (min-width:768px){body{font-size:15px}}html{color:#222;font-weight:100;font-size:1em;font-family:Open Sans,Verdana,sans-serif;line-height:1.375}body{margin:0}a{color:#0074c2}::-moz-selection{background:#b3d4fc;text-shadow:none}::selection{background:#b3d4fc;text-shadow:none}hr{display:block;height:1px;border:0;border-top:1px solid #ccc;margin:1em 0;padding:0}audio,canvas,iframe,img,svg,video{vertical-align:middle}fieldset{border:0;margin:0;padding:0}textarea{resize:vertical}button,input[type=submit]{cursor:pointer}.browserupgrade{margin:.2em 0;background:#ccc;color:#000;padding:.2em 0}@media print{*,:after,:before{background:transparent!important;color:#000!important;-webkit-box-shadow:none!important;box-shadow:none!important;text-shadow:none!important}a,a:visited{text-decoration:underline}a[href]:after{content:\" (\" attr(href) \")\"}abbr[title]:after{content:\" (\" attr(title) \")\"}a[href^=\"#\"]:after,a[href^=\"javascript:\"]:after{content:\"\"}blockquote,pre{border:1px solid #999;page-break-inside:avoid}thead{display:table-header-group}img,tr{page-break-inside:avoid}img{max-width:100%!important}h2,h3,p{orphans:3;widows:3}h2,h3{page-break-after:avoid}}.JTR6W{min-height:100vh;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.ciN7r{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}", ""]);

// exports
exports.locals = {
	"active": "NEn17",
	"wrapper": "JTR6W",
	"content": "ciN7r"
};

/***/ }),

/***/ 745:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(746);
    var insertCss = __webpack_require__(622);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Header.css", function() {
        content = require("!!../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Header.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 746:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(621)(false);
// imports


// module
exports.push([module.i, ".slides .slick-prev{z-index:1;left:5%;background-color:#fff}.slides .slick-next{z-index:1;right:5%;background-color:#fff}.slides .slick-next:before,.slides .slick-prev:before{color:#10949d}.justify-content-center{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;display:-webkit-box;display:-ms-flexbox;display:flex}.m-1{margin:4px;margin:.25rem}.m-2{margin:8px;margin:.5rem}.mb-1{margin-bottom:8px;margin-bottom:.5rem}.mb-2{margin-bottom:4px;margin-bottom:.25rem}.mt-1{margin-top:4px;margin-top:.25rem}.mt-2{margin-top:8px;margin-top:.5rem}.mr-1{margin-right:4px;margin-right:.25rem}.mr-2{margin-right:8px;margin-right:.5rem}.ml-1{margin-left:4px;margin-left:.25rem}.ml-2{margin-left:8px;margin-left:.5rem}.align-items-center{-webkit-box-align:center;-ms-flex-align:center;align-items:center}.d-flex{display:-webkit-box;display:-ms-flexbox;display:flex}.flex-column{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.img-fluid{max-width:100%;height:auto}.navbar-default .navbar-nav>li>a{color:#000;font-size:16px;font-weight:400;line-height:1.5}i,input[type=checkbox],input[type=file]{cursor:pointer}input[type=checkbox]._2kEIa,input[type=checkbox]:active,input[type=checkbox]:focus{background-image:none;outline:0;-webkit-box-shadow:none;box-shadow:none}.btn-primary{background-color:#10949d}.btn-success{background-color:#00b2a6}.btn-warning{background-color:#efca75}.btn-danger{background-color:#e67e69}#g-recaptcha{width:100%;margin:0 auto;padding-left:17px}section{height:100%;width:100%}.rbc-time-content{display:none}.carousel-indicators .active{background:gray}@media (min-width:768px){body{font-size:15px}}._2oS_y{display:inline-block}.O9oW9{color:#fff}.qQ2mF{margin:0 auto;max-width:1000px}@media (max-width:767px){.qQ2mF ._1qRCL{margin:0}.qQ2mF ._19oQj{margin:15px 0 0}._19oQj{padding:0 20px;margin-top:15px}}._19oQj{margin-top:20px}@media (max-width:1010px){._2oS_y{padding:0 10px}}.zVR7n{background-color:#fff;border:none}._2jKwz{margin-top:15px;width:150px;height:73px}", ""]);

// exports
exports.locals = {
	"active": "_2kEIa",
	"brand": "_2oS_y",
	"root": "O9oW9",
	"container": "qQ2mF",
	"header": "_1qRCL",
	"collapse": "_19oQj",
	"navBarCustom": "zVR7n",
	"logo": "_2jKwz"
};

/***/ }),

/***/ 747:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(748);
    var insertCss = __webpack_require__(622);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Navigation.css", function() {
        content = require("!!../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Navigation.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 748:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(621)(false);
// imports


// module
exports.push([module.i, "._2gcJx{float:right;margin:6px 0 0}.K_Eej{margin:0 auto}._2UNlq{margin-right:8px;margin-left:8px;border-radius:3px;background:rgba(0,178,166,.2);color:#fff}._2UNlq:hover{background:#efca75}._2FtSN li{margin:0 2px}@media (min-width:768px){.K_Eej ._17W9R{right:auto;left:0}}@media (max-width:767px){._2UNlq{margin:0}}.Ntl35:hover{background-color:#efca75!important;color:#fff!important}._3Zayd{border-right:2px solid hsla(9,70%,79%,.8)}", ""]);

// exports
exports.locals = {
	"root": "_2gcJx",
	"navbar": "K_Eej",
	"highlight": "_2UNlq",
	"default": "_2FtSN",
	"menu": "_17W9R",
	"link": "Ntl35",
	"divider": "_3Zayd"
};

/***/ }),

/***/ 749:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "cd204755.jpg";

/***/ }),

/***/ 750:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(751);
    var insertCss = __webpack_require__(622);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Footer.css", function() {
        content = require("!!../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Footer.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 751:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(621)(false);
// imports


// module
exports.push([module.i, ".slides .slick-prev{z-index:1;left:5%;background-color:#fff}.slides .slick-next{z-index:1;right:5%;background-color:#fff}.slides .slick-next:before,.slides .slick-prev:before{color:#10949d}.justify-content-center{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;display:-webkit-box;display:-ms-flexbox;display:flex}.m-1{margin:4px;margin:.25rem}.m-2{margin:8px;margin:.5rem}.mb-1{margin-bottom:8px;margin-bottom:.5rem}.mb-2{margin-bottom:4px;margin-bottom:.25rem}.mt-1{margin-top:4px;margin-top:.25rem}.mt-2{margin-top:8px;margin-top:.5rem}.mr-1{margin-right:4px;margin-right:.25rem}.mr-2{margin-right:8px;margin-right:.5rem}.ml-1{margin-left:4px;margin-left:.25rem}.ml-2{margin-left:8px;margin-left:.5rem}.align-items-center{-webkit-box-align:center;-ms-flex-align:center;align-items:center}.d-flex{display:-webkit-box;display:-ms-flexbox;display:flex}.flex-column{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.img-fluid{max-width:100%;height:auto}.navbar-default .navbar-nav>li>a{color:#000;font-size:16px;font-weight:400;line-height:1.5}i,input[type=checkbox],input[type=file]{cursor:pointer}input[type=checkbox]._2RPGs,input[type=checkbox]:active,input[type=checkbox]:focus{background-image:none;outline:0;-webkit-box-shadow:none;box-shadow:none}.btn-primary{background-color:#10949d}.btn-success{background-color:#00b2a6}.btn-warning{background-color:#efca75}.btn-danger{background-color:#e67e69}#g-recaptcha{width:100%;margin:0 auto;padding-left:17px}section{height:100%;width:100%}.rbc-time-content{display:none}.carousel-indicators .active{background:gray}@media (min-width:768px){body{font-size:15px}}._1UUMy{margin-top:50px}._3dfAC{margin:0 auto;padding:20px 15px}.bF0OS{font-size:20px}.bF0OS i{margin-right:10px}._3ReUN{font-size:15px;margin-top:20px;width:65%}._1l1aJ{margin-top:10px;font-size:18px}._2uaRc{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}._3iJ8u{border-color:#10949d;margin:30px 0}", ""]);

// exports
exports.locals = {
	"active": "_2RPGs",
	"root": "_1UUMy",
	"container": "_3dfAC",
	"icon": "bF0OS",
	"text": "_3ReUN",
	"register": "_1l1aJ",
	"customRow": "_2uaRc",
	"line": "_3iJ8u"
};

/***/ })

});


// WEBPACK FOOTER //
// about.88c0da2b.chunk.js